// extracted by mini-css-extract-plugin
module.exports = {"reactions":"ReactionList_reactions__11eM-"};